module.exports = __webpack_public_path__ + "static/img/model3-2.99403a16.jpg";